export default "__VITE_ASSET__CYNKUBxJ__"